import { render, staticRenderFns } from "./OpportunityStatus.vue?vue&type=template&id=7cb27f70&"
import script from "./OpportunityStatus.vue?vue&type=script&lang=js&"
export * from "./OpportunityStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports